
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.2 4.7c.3 0 .6.1.8.3.2.2.4.5.4.8v5.9c0 .3-.1.6-.4.8-.2.2-.5.3-.8.3h-7c-.3 0-.6-.1-.8-.3-.3-.2-.4-.5-.4-.8V5.8c0-.3.1-.6.4-.8.2-.2.5-.3.8-.3h.6V3.5c0-.8.3-1.5.9-2.1C3.3.8 4 .5 4.8.5s1.5.3 2.1.9c.6.6.9 1.3.9 2.1v1.2h.4zm-1.7 0V3.5c0-.5-.2-.9-.5-1.3s-.8-.5-1.3-.5-.9.2-1.3.5-.5.8-.5 1.3v1.2h3.6zM3.9 9.6c.2.2.5.3.8.3.3 0 .6-.1.8-.4.2-.2.4-.5.4-.8 0-.3-.1-.6-.4-.8-.2-.2-.5-.4-.8-.4-.3 0-.6.1-.8.4-.2.2-.4.5-.4.8 0 .4.1.6.4.9z","fill":"#1BAD00"}})])
          )
        }
      }
    